/**
 * Combined language + currency selector.
 *
 * Markup is rendered by snippets/language-switcher.liquid: a toggle button and a
 * popover panel of options, each carrying data-country + data-locale. Selecting
 * an option writes both values into the localization form's hidden inputs and
 * submits, switching language and currency together in a single request.
 */
if (!customElements.get("c-language-switcher")) {
  customElements.define(
    "c-language-switcher",
    class LanguageSwitcher extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.toggle = this.querySelector(".js-language-switcher__toggle");
        this.panel = this.querySelector(".c-language-switcher__panel");
        this.options = Array.from(
          this.querySelectorAll(".js-language-switcher__option")
        );
        this.countryInput = this.querySelector('input[name="country_code"]');
        this.localeInput = this.querySelector('input[name="locale_code"]');

        this.onToggleClick = this.onToggleClick.bind(this);
        this.onOptionClick = this.onOptionClick.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
      }

      connectedCallback() {
        if (!this.form || !this.toggle || !this.panel) return;

        this.toggle.addEventListener("click", this.onToggleClick);
        this.options.forEach((option) =>
          option.addEventListener("click", this.onOptionClick)
        );
        document.addEventListener("click", this.onDocumentClick);
        this.addEventListener("keydown", this.onKeydown);
      }

      disconnectedCallback() {
        this.toggle.removeEventListener("click", this.onToggleClick);
        this.options.forEach((option) =>
          option.removeEventListener("click", this.onOptionClick)
        );
        document.removeEventListener("click", this.onDocumentClick);
        this.removeEventListener("keydown", this.onKeydown);
      }

      get isOpen() {
        return this.toggle.getAttribute("aria-expanded") === "true";
      }

      open() {
        this.toggle.setAttribute("aria-expanded", "true");
        this.panel.hidden = false;

        const current =
          this.panel.querySelector(".is-current") || this.options[0];
        if (current) current.focus();
      }

      close({ focusToggle = false } = {}) {
        this.toggle.setAttribute("aria-expanded", "false");
        this.panel.hidden = true;
        if (focusToggle) this.toggle.focus();
      }

      onToggleClick(event) {
        event.stopPropagation();
        if (this.isOpen) {
          this.close();
        } else {
          this.open();
        }
      }

      onOptionClick(event) {
        const option = event.currentTarget;
        const { country, locale } = option.dataset;

        if (country && this.countryInput) this.countryInput.value = country;
        if (locale && this.localeInput) this.localeInput.value = locale;

        this.form.submit();
      }

      onDocumentClick(event) {
        if (this.isOpen && !this.contains(event.target)) this.close();
      }

      onKeydown(event) {
        if (!this.isOpen) return;

        if (event.key === "Escape") {
          event.stopPropagation();
          this.close({ focusToggle: true });
          return;
        }

        if (event.key === "ArrowDown" || event.key === "ArrowUp") {
          event.preventDefault();
          if (!this.options.length) return;

          const currentIndex = this.options.indexOf(document.activeElement);
          const direction = event.key === "ArrowDown" ? 1 : -1;
          const nextIndex =
            (currentIndex + direction + this.options.length) %
            this.options.length;
          this.options[nextIndex].focus();
        }
      }
    }
  );
}
